import firebase from "./firebaseSetUp";
export default firebase